export default [{
  label: '水湖镇',
  value: 340121100000
}, {
  label: '庄墓镇',
  value: 340121101000
}, {
  label: '杨庙镇',
  value: 340121102000
}, {
  label: '吴山镇',
  value: 340121103000
}, {
  label: '岗集镇',
  value: 340121104000
}, {
  label: '双墩镇',
  value: 340121105000
}, {
  label: '下塘镇',
  value: 340121106000
}, {
  label: '朱巷镇',
  value: 340121107000
}, {
  label: '陶楼镇',
  value: 340121109000
}, {
  label: '杜集镇',
  value: 340121110000
}, {
  label: '罗塘乡',
  value: 340121200000
}, {
  label: '义井乡',
  value: 340121201000
}, {
  label: '造甲乡',
  value: 340121203000
}, {
  label: '左店乡',
  value: 340121204000
}, {
  label: '双凤开发区',
  value: 340121400000
}, {
  label: '安徽省水家湖农场',
  value: 340121401000
}]



// WEBPACK FOOTER //
// ./src/common/towns.js